import React, { useState } from 'react';

import { Col, Dropdown, Modal } from 'react-bootstrap';
import '../JobStageSummary.scss';
import Textfield from '../../../_common/Textfield/Textfield';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { useQuery } from '@apollo/client/react';
import { GET_WELL_HEADS_BY_STAGE_GROUP_ID } from '../../../../graphql/client/queries';
import { GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageWellheads } from '../../../../types/schemaTypes';
import { Loading } from '../../../_common/Loading/Loading';

interface EndStageModalProps {
    showEndStageModal: boolean;
    stageStatusData: any;
    handleOnClose: (modalType) => void;
    handleOnSave: (jobStageIds: number[], comments: string) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const EndStageModal = ({
    showEndStageModal,
    handleOnClose,
    stageStatusData,
    handleOnSave,
    mutationLoading,
    mutationError,
}: EndStageModalProps): React.ReactElement => {
    const [wellheadStage, setWellheadStage] = useState<string>();
    const [comments, setComments] = useState<string>('');
    const [jobStageIds, setJobStageIds] = useState<number[]>();

    // let { loading, error, data } = useQuery(GET_WELL_HEADS_BY_STAGE_GROUP_ID, {
    //     variables: {
    //         stageGroupId: 1,
    //     },
    //     fetchPolicy: 'network-only',
    // });
    const wellheadStageList: any[] = [];
    debugger;
    if (stageStatusData && stageStatusData.stageStatus) {
        stageStatusData.stageStatus.map(wellHead => {
            if (wellHead.status == 'Paused' || wellHead.status == 'Running') {
                wellheadStageList.push(wellHead);
            }
        });
    }

    const onClickClose = () => {
        handleOnClose('endStage');
    };

    const onClickSave = () => {
        if (jobStageIds) handleOnSave(jobStageIds, comments);
    };

    const handleOnChangeWellheadStage = (wellhead: string, jobStageId: number) => {
        if (wellhead === 'ALL') {
            const tempJobStageIds: number[] = [];
            wellheadStageList.map(WellheadStageItem => {
                tempJobStageIds.push(WellheadStageItem.stageId);
            });
            setWellheadStage('Select All');
            setJobStageIds(tempJobStageIds);
        } else {
            setWellheadStage(`${wellhead} `);
            setJobStageIds([jobStageId]);
        }
    };

    const handleOnChangeComments = (value: string) => {
        setComments(value);
    };

    if (wellheadStageList.length === 1 && !wellheadStage) {
        handleOnChangeWellheadStage(
            wellheadStageList[0].wellHead,
            //wellheadStageList[0].stage,
            wellheadStageList[0].stageId,
        );
    }
    if (wellheadStageList.length > 1 && !wellheadStage) {
        handleOnChangeWellheadStage('ALL', 0);
    }

    return (
        <Modal show={showEndStageModal} onHide={onClickClose} dialogClassName="StageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">End Stage</div>
                    <div className="AddStageModal-Error">{mutationError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                <Col>
                    <div>
                        Select a Wellhead-Stage below and provide comments (if any) and click continue to proceed.
                    </div>
                </Col>
                <Col>
                    <div>
                        <b>
                            ALL FULL BOXES WILL BE MOVED TO UNASSIGNED INVENTORY AND PARTIAL BOXES WILL BE MOVED TO THE
                            DANCE FLOOR
                        </b>
                    </div>
                </Col>

                <Col md={8}>
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic" className="EndStage-wellheadStage">
                            <span>{wellheadStage}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {wellheadStageList.length > 1 && (
                                <Dropdown.Item
                                // onSelect={() => handleOnChangeWellheadStage('ALL', 0)}
                                onClick={() => handleOnChangeWellheadStage('ALL', 0)}
                                 >
                                    Select All
                                </Dropdown.Item>
                            )}
                            {wellheadStageList.map((wellheadStageItem, index) => (
                                <Dropdown.Item
                                    key={index}
                                    // onSelect={() =>
                                    //     handleOnChangeWellheadStage(
                                    //         wellheadStageItem.wellHead,
                                    //         //wellheadStageItem.stage,
                                    //         wellheadStageItem.stageId,
                                    //     )
                                    // }
                                    onClick={() =>
                                        handleOnChangeWellheadStage(
                                            wellheadStageItem.wellHead,
                                            //wellheadStageItem.stage,
                                            wellheadStageItem.stageId,
                                        )
                                    }
                                >
                                    {wellheadStageItem.wellHead}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>

                <Col md={8}>
                    <Textfield
                        label="Comments (optional)"
                        name="endStageComments"
                        onChange={element => handleOnChangeComments(element.target.value)}
                        maxLength={1000}
                    />
                </Col>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton
                    title="Continue"
                    onClick={() => onClickSave()}
                    isDisabled={jobStageIds && !mutationLoading ? false : true}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default EndStageModal;
